interface ImportMetaEnv {
	readonly VITE_APP_TITLE: string
	readonly VITE_DOMAIN: string
	// more env variables...
}

declare global {
	interface ImportMeta {
		readonly env: ImportMetaEnv
	}
}

export const isNativeDevice = import.meta.env.MODE === "tizen"
export const appVersion = "1.0.16"
const policy_uuid = "527d185f-733e-481d-b148-0dc36e0b6d31"
const terms_uuid = "0ef67987-fb97-48b1-ab60-ce50e7dd9853"

// const url = import.meta.env.VITE_DOMAIN
// let url = "https://back.valor-movies.e-sepia.gr"
let url = import.meta.env.VITE_BACKEND_URL
// if (import.meta.env.MODE === "staging" || import.meta.env.MODE === "production") {
// 	url = "https://ext.valormovies.com"
// }
export { url, policy_uuid, terms_uuid }
